(function() {
    'use strict';

    angular.module('allegro').directive('allegroAccountCard', allegroAccountCard);

    allegroAccountCard.$inject = [
        '$timeout',
        '$state',
        'checkModelPermissionsSrvc',
        'allegroConfigPermissionsConst',
        'allegroSellerPermissionsConst',
        'allegroSenderPermissionsConst',
        'allegroCodReceiverPermissionsConst',
        'allegroResponsibleProducerPermissionsConst',
        'allegroSafetyInformationPermissionsConst'
    ];

    function allegroAccountCard(
        $timeout,
        $state,
        checkModelPermissionsSrvc,
        allegroConfigPermissionsConst,
        allegroSellerPermissionsConst,
        allegroSenderPermissionsConst,
        allegroCodReceiverPermissionsConst,
        allegroResponsibleProducerPermissionsConst,
        allegroSafetyInformationPermissionsConst
    ){
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/allegro/directives/account-card/account-card.html',
            scope: {
                account: '=',
                onGetDeviceFlow: '&',
                onRevokeAccessToken: '&',
                onRefreshAuthInfo: '&'
            },
            link: function(scope, element, attrs) {
                // Add Inspinia animation class
                element.find('.ibox').addClass('animated fadeInUp');
                scope.loading = false;

                scope.getDeviceFlow = getDeviceFlow;
                scope.refreshAuthInfo = refreshAuthInfo;
                scope.revokeAccessToken = revokeAccessToken;
                scope.openVerificationUri = openVerificationUri;
                scope.hasMissingSettings = hasMissingSettings;

                scope.hasAssociationPermissions = hasAssociationPermissions;
                scope.hasRevokeTokenPermissions = hasRevokeTokenPermissions;
                scope.hasAnySettingsPerm = hasAnySettingsPerm;

                scope.refreshAuthInfo();

                function getDeviceFlow(account){
                    scope.onGetDeviceFlow(account);
                }

                function revokeAccessToken(account){
                    scope.onRevokeAccessToken(account)
                }

                function refreshAuthInfo(account){
                    scope.onRefreshAuthInfo(account)
                }

                function openVerificationUri(account) {
                    if (account.configuration.device_flow &&
                        account.configuration.device_flow.verification_uri_complete) {
                        window.open(account.configuration.device_flow.verification_uri_complete, '_blank');
                    }
                }

                function hasMissingSettings(account) {
                    var accountSettings = account.settings_fill_statuses;
                    if (!accountSettings) {
                        return false;
                    }

                    return Object.keys(accountSettings).some(function(key){
                        return accountSettings[key] && !accountSettings[key].filled;
                    });
                }

                function hasAssociationPermissions() {
                    return !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.update);
                }

                function hasRevokeTokenPermissions() {
                    return !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.delete);
                }

                function hasAnySettingsPerm() {
                    return (
                        !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.view) ||
                        !checkModelPermissionsSrvc.isDenied(allegroSellerPermissionsConst.view) ||
                        !checkModelPermissionsSrvc.isDenied(allegroSenderPermissionsConst.view) ||
                        !checkModelPermissionsSrvc.isDenied(allegroCodReceiverPermissionsConst.view) ||
                        !checkModelPermissionsSrvc.isDenied(allegroResponsibleProducerPermissionsConst.view) ||
                        !checkModelPermissionsSrvc.isDenied(allegroSafetyInformationPermissionsConst.view)
                    );
                }
            }
        };
    }
})();
